import { ArrowRight, CalendarCheck, Users, Flame } from "lucide-react";
import { Link } from "react-router-dom";

const HERO_IMG =
    "https://images.pexels.com/photos/7295867/pexels-photo-7295867.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1100";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 overflow-hidden"
        >
            {/* mesh blobs */}
            <div className="pointer-events-none absolute -top-32 right-0 h-[560px] w-[560px] rounded-full bg-brand-100/60 blur-3xl animate-blob" />
            <div className="pointer-events-none absolute bottom-0 -left-32 h-[420px] w-[420px] rounded-full bg-pinky-100/50 blur-3xl animate-blob" />

            <div className="container-wide relative grid lg:grid-cols-12 gap-12 items-center">
                <div className="lg:col-span-6 animate-fade-up">
                    <span data-testid="hero-eyebrow" className="eyebrow-brand">
                        Méthode basée sur les neurosciences
                    </span>
                    <h1
                        data-testid="hero-title"
                        className="display-1 mt-6"
                    >
                        Développez le{" "}
                        <span className="text-brand-500 relative inline-block">
                            potentiel
                            <svg
                                aria-hidden="true"
                                viewBox="0 0 200 14"
                                className="absolute left-0 -bottom-3 w-full h-3"
                                preserveAspectRatio="none"
                            >
                                <path
                                    d="M2 10 C 60 2 140 2 198 8"
                                    stroke="#14B8A6"
                                    strokeWidth="3"
                                    fill="none"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </span>{" "}
                        de votre enfant.
                    </h1>

                    <p
                        data-testid="hero-subtitle"
                        className="body-lg mt-8 max-w-xl"
                    >
                        Découvrez en 3 minutes son <strong className="text-ink-900">profil neuro-éducatif</strong> et
                        recevez un plan d'action concret. Résultats visibles en quelques semaines.
                    </p>

                    <div className="mt-10 flex flex-wrap items-center gap-3">
                        <Link
                            data-testid="hero-test-cta"
                            to="/test"
                            className="btn-fire group"
                        >
                            <Flame className="mr-2 h-4 w-4 animate-fire-flicker" strokeWidth={2.5} />
                            Faire le test gratuit
                            <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={2.5} />
                        </Link>
                        <Link data-testid="hero-diagnostic-cta" to="/diagnostic" className="btn-outline">
                            <CalendarCheck className="mr-2 h-4 w-4" strokeWidth={2} />
                            Diagnostic offert
                        </Link>
                    </div>

                    <div className="mt-12 flex items-center gap-4">
                        <div className="flex -space-x-3">
                            {[1, 2, 3, 4].map((i) => (
                                <span
                                    key={i}
                                    className="h-10 w-10 rounded-full bg-brand-500 grid place-items-center text-white ring-2 ring-white"
                                >
                                    <Users className="h-4 w-4" strokeWidth={2} />
                                </span>
                            ))}
                        </div>
                        <div className="text-sm">
                            <p className="font-semibold text-ink-900">+500 parents</p>
                            <p className="text-ink-500">accompagnés</p>
                        </div>
                    </div>
                </div>

                <div className="lg:col-span-6 relative animate-fade-in">
                    <div className="relative rounded-[2.5rem] overflow-hidden ring-soft-brand">
                        <img
                            src={HERO_IMG}
                            alt="Parents accompagnant leur enfant dans l'apprentissage"
                            data-testid="hero-image"
                            className="w-full h-[560px] object-cover"
                            loading="eager"
                        />
                    </div>
                    {/* floating stat */}
                    <div className="hidden md:flex absolute -left-6 bottom-10 soft-card items-center gap-3 px-5 py-4">
                        <span className="h-10 w-10 rounded-xl bg-brand-50 grid place-items-center text-brand-600 font-bold">
                            3'
                        </span>
                        <div>
                            <p className="text-xs uppercase tracking-widest text-ink-500">Test gratuit</p>
                            <p className="font-semibold text-ink-900 text-sm">Résultats immédiats</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
